<template>
    <div>
        <!-- Modal Component -->
        <b-modal id="login_modal" ref="login_modal" :title="$t('message.login')" @shown="clearLoginData">
            <form @submit.stop.prevent="login" @keyup.enter="login" ref="loginModalForm">
                <b-alert variant="danger" :show="loginError.show">
                    {{ loginError.message }}
                </b-alert>

                <div class="form-group">
                    <b-form-input ref="login_modal_input" type="text" :placeholder="$t('user.username')" v-model="user.login"></b-form-input>
                </div>
                <div class="form-group">
                    <input id="loginPasswordId" class="form-control" type="password" :placeholder="$t('user.password')" v-model="user.password" v-on:keyup="onPasswordInput"/>
                </div>
                <b-tooltip ref="capsLockTooltip" target="loginPasswordId" placement="bottom" disabled>
                  {{ $t('forms.capsLockOn') }}                  
                </b-tooltip>                
            </form>

            <a href="#" v-on:click="passwordResetModal" class="reset-password-link">{{ $t('user.passwordForgotten') }}</a>

            <div slot="modal-footer">
                <a href="#" v-on:click="initialLoginModal" class="initial-login-link">{{ $t('user.firstTimeLogin') }}</a>
                <button class="btn btn-primary" @click="login" :disabled="load">{{ $t('forms.submit') }}
                    <loader :show="load" type="button"></loader>
                </button>
            </div>

        </b-modal>

        <!-- Initial login modal Component -->
        <b-modal id="initial_login_modal" ref="initial_login_modal" :title="$t('message.login')" ok-only @shown="clearInitialLoginData">
            <form @submit.stop.prevent="initialLogin" ref="initialLoginModalForm">
                <b-alert variant="danger" :show="loginError.show">
                    {{ loginError.message }}
                </b-alert>

                <div class="form-group">
                    <b-form-input ref="initial_login_modal_input" type="text" :placeholder="$t('user.username')" v-model="user.login"></b-form-input>
                </div>
            </form>

            <div slot="modal-footer">
                <button class="btn btn-primary" @click="initialLogin" :disabled="load">{{ $t('forms.submit') }}
                    <loader :show="load" type="button"></loader>
                </button>
            </div>
        </b-modal>

        <!-- Reset password modal Component -->
        <b-modal id="password_reset_modal" ref="password_reset_modal" :title="$t('user.passwordForgotten')" ok-only @shown="clearPasswordResetData">
            <form @submit.stop.prevent="resetPassword" ref="passwordResetModalForm">
                <b-alert variant="danger" :show="loginError.show">
                    {{ loginError.message }}
                </b-alert>

                <div class="form-group">
                    <b-form-input  ref="password_reset_modal_input" type="text" :placeholder="$t('user.username')" v-model="user.login"></b-form-input>
                </div>
            </form>

            <div slot="modal-footer">
                <button class="btn btn-primary" @click="resetPassword" :disabled="load">{{ $t('forms.submit') }}
                    <loader :show="load" type="button"></loader>
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { setCredentials } from '@/router/auth'
  import { EventBus } from '@/router/bus'
  import Loader from '@/components/misc/Loader'

  export default {
    name: 'login',
    data () {
      return {
        user: {},
        loginError: {
          show: false,
          message: ''
        },
        load: false
      }
    },
    components: {
      Loader
    },
    mounted () {
      if (this.$route.query.redirect) {
        this.$refs.login_modal.show()
      }
    },
    methods: {
      hideModal () {
        this.$refs.login_modal.hide()
        this.$refs.initial_login_modal.hide()
        this.$refs.password_reset_modal.hide()
        this.load = false
      },
      login (e) {
        this.load = true
        this.loginError['show'] = false

        let loginUrl = Vue.$apiConfig.login

        this.user.login = this.$refs.login_modal_input.$el.value

        this.logConsole('Sending login request for user : ' + this.user.login)
        this.$http.post(loginUrl, this.user)
          .then(response => {
            // get body data
            let data = response.data
            setCredentials(this.user.login, data.payload.accessToken, data.payload.refreshToken)
            this.hideModal()
            this.gotoInitialPage()
            EventBus.$emit('logged-in', 'asd')
          }, error => {
            this.logConsole(error)
            this.load = false
            this.loginError['show'] = true

            if (error.status === 0) {
              this.loginError['message'] = this.$t('apiStatusCodes.0')
            } else if (error.status === 422) {
              this.loginError['message'] = this.$t('apiStatusCodes.' + error.data.errors[0].code)
            } else {
              this.loginError['message'] = this.$t('apiStatusCodes.' + error.data.status.code)
            }

            if (error.data.additionalInformation) {
              this.loginError['message'] += ' : ' + error.data.additionalInformation
            }
          })
        if (typeof e.cancel !== 'undefined' && typeof e.cancel === 'function') {
          return e.cancel()
        }
      },
      initialLogin () {
        this.load = true
        this.logConsole('Sending initial login request')

        this.$http.post(Vue.$apiConfig.activateRegisteredUserPost, this.user)
          .then(response => {
            this.logConsole(response)
            this.hideModal()

            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$translate('activation.activationSent'),
              errors: []
            })
          }, error => {
            this.logConsole(error)
            this.load = false
            this.loginError['show'] = true

            let statusCode = 0
            if (error.status !== 0) { statusCode = error.data.status.code }

            this.loginError['message'] = this.$translate('apiStatusCodes.' + statusCode)
          })
      },
      resetPassword () {
        this.load = true
        this.logConsole('Sending password reset request')

        this.$http.post(Vue.$apiConfig.resetUserPasswordPost, this.user)
          .then(response => {
            this.logConsole(response)
            this.hideModal()

            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$translate('user.passwordResetLinkSent'),
              errors: []
            })
          }, error => {
            this.logConsole(error)
            this.load = false
            this.loginError['show'] = true

            let statusCode = 0
            if (error.status !== 0) { statusCode = error.data.status.code }

            this.loginError['message'] = this.$translate('apiStatusCodes.' + statusCode)
          })
      },
      initialLoginModal () {
        this.logConsole('initial login')
        this.hideModal()

        this.$refs.initial_login_modal.show()
      },
      passwordResetModal () {
        this.logConsole('reset password')
        this.hideModal()

        this.$refs.password_reset_modal.show()
      },
      gotoInitialPage () {
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect)
        } else {
          this.$router.push('/dashboard')
        }
      },
      onPasswordInput (e) {
        if (e.key) {
          let s = e.key
          if (s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey) {
            this.$refs.capsLockTooltip.$emit('enable')
            this.$refs.capsLockTooltip.$emit('open')
          } else {
            this.$refs.capsLockTooltip.$emit('close')
            this.$refs.capsLockTooltip.$emit('disable')
          }
        }
      },
      clearLoginData () {
        this.$refs.loginModalForm.reset()
        this.clearData()
        this.$refs.login_modal_input.focus()
      },
      clearInitialLoginData () {
        this.$refs.initialLoginModalForm.reset()
        this.clearData()
        this.$refs.initial_login_modal_input.focus()
      },
      clearPasswordResetData () {
        this.$refs.passwordResetModalForm.reset()
        this.clearData()
        this.$refs.password_reset_modal_input.focus()
      },
      clearData () {
        this.loginError['show'] = false
        this.user.login = null
        this.user.password = null
      }
    }
  }
</script>
<style lang="scss" type="text/scss" scoped>

  @import '~@/assets/scss/variables.scss';

  .reset-password-link {
    color: $primary-color-accent;
    font-size: 11pt;
    margin-left: 5px;
  }

  .initial-login-link {
    color: $primary-color-devel;
    margin: 10px;
    font-weight: 600;
  }

</style>



// WEBPACK FOOTER //
// Login.vue?4c5d8b68